import React from 'react';
import { WebsiteDesignProps } from './types';
import { Trophy, Timer } from 'lucide-react';
import { Button } from "@/components/ui/button";

const SportsManagement: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Sports Business Institute";

    return (
        <div className="bg-[#0f0f0f] min-h-screen font-sans text-white">
            <nav className="bg-[#1a1a1a] border-b border-[#333] px-8 py-4 flex justify-between items-center sticky top-0 z-50">
                <div className="flex items-center gap-3 font-black text-xl uppercase tracking-tight">
                    <Trophy className="text-[#00ff87]" fill="currentColor" fillOpacity={0.2} /> {schoolName}
                </div>
                <div className="hidden md:flex gap-6 text-xs uppercase tracking-widest font-bold text-gray-400">
                    <a href="#" className="hover:text-[#00ff87]">Programs</a>
                    <a href="#" className="hover:text-[#00ff87]">Network</a>
                    <a href="#" className="hover:text-[#00ff87]">Careers</a>
                </div>
                <Button className="bg-[#00ff87] text-black hover:bg-[#00cc6a] font-black uppercase text-xs tracking-widest rounded">
                    Apply
                </Button>
            </nav>

            <header className="relative py-24 px-8 overflow-hidden">
                {/* Dynamic Lines */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-1/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00ff87] to-transparent"></div>
                    <div className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00ff87] to-transparent"></div>
                    <div className="absolute top-3/4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00ff87] to-transparent"></div>
                </div>

                <div className="container mx-auto relative z-10">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-2 bg-[#00ff87]/10 border border-[#00ff87]/30 text-[#00ff87] px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest mb-8">
                            <Timer size={14} /> Live Your Passion
                        </div>
                        <h1 className="text-5xl md:text-7xl font-black uppercase mb-8 leading-none tracking-tight">
                            The Business <br/> of <span className="text-[#00ff87]">Winning.</span>
                        </h1>
                        <p className="text-xl text-gray-400 mb-10 max-w-lg leading-relaxed">
                            Train for leadership roles in professional sports, esports, and athletic brand management.
                        </p>
                        <div className="flex flex-wrap gap-4">
                            <Button className="bg-white text-black hover:bg-gray-200 font-black uppercase tracking-wider px-8 h-14 rounded">
                                MBA in Sports
                            </Button>
                            <Button variant="outline" className="border-[#00ff87] text-[#00ff87] hover:bg-[#00ff87]/10 font-black uppercase tracking-wider px-8 h-14 rounded">
                                Executive Ed
                            </Button>
                        </div>
                    </div>
                </div>
            </header>

            <section className="bg-[#1a1a1a] py-16 border-t border-[#333]">
                <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { stat: "$180B", label: "Global Sports Market" },
                        { stat: "94%", label: "Job Placement Rate" },
                        { stat: "500+", label: "Partner Organizations" },
                    ].map((item, i) => (
                        <div key={i} className="text-center p-8 border border-[#333] hover:border-[#00ff87] transition-colors rounded">
                            <div className="text-4xl font-black text-[#00ff87] mb-2">{item.stat}</div>
                            <div className="text-xs uppercase tracking-widest text-gray-500">{item.label}</div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default SportsManagement;
